import { render, staticRenderFns } from "./OneCartIconComponent.vue?vue&type=template&id=fe0da9b2&scoped=true&"
import script from "./OneCartIconComponent.vue?vue&type=script&lang=ts&"
export * from "./OneCartIconComponent.vue?vue&type=script&lang=ts&"
import style0 from "./OneCartIconComponent.vue?vue&type=style&index=0&id=fe0da9b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0da9b2",
  null
  
)

export default component.exports